import { render, staticRenderFns } from "./ClueSearchManage.vue?vue&type=template&id=650c0489&"
import script from "./ClueSearchManage.vue?vue&type=script&lang=js&"
export * from "./ClueSearchManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports